import firebase from "firebase/app";
import "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC8-fakei0ylxA1w0CunfDEo6pWzp0Flew",
  authDomain: "alroaaacademyblog.firebaseapp.com",
  projectId: "alroaaacademyblog",
  storageBucket: "alroaaacademyblog.appspot.com",
  messagingSenderId: "4652002287",
  appId: "1:4652002287:web:978890bd98fc49df06241a",
  measurementId: "G-KBZGLMKZXW",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const timestamp = firebase.firestore.FieldValue.serverTimestamp;

export { timestamp };
export default firebaseApp.firestore();
